module.exports = __webpack_public_path__ + "static/img/pro10_tab2.48089c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro10_tab2.jpg
// module id = muQy
// module chunks = 171